import at from '../actionTypes'
import createReducer from './utilities/createReducer'
import defaultFeatureTypes from '../../enums/defaultFeatureTypes'
import { featureTypes } from '../../components/FeatureTranslate'
import voteTypes from '../../enums/voteTypes'
import that from '../../utilities/translationHelper'
import maybe from '../../utilities/maybe'
import showAppMessage from './utilities/showAppMessage'

const getDefaultFeatureTypes = (type) => {
	const myType = defaultFeatureTypes[type]
	return myType || defaultFeatureTypes.DEFAULT || []
}

// Get the value of a vote - before votes are negated, so the difference is set back to 0
const voteValue = (voteType, isBefore) => {
	let value = voteType === voteTypes.UP.type ? 1 : 0

	if (voteType === voteTypes.DOWN.type) {
		value = -1
	}

	return isBefore ? -value : value
}

export default createReducer({}, {
	[at.itemFetch_Begin]: (state) => {
		const newState = { ...state }
		delete newState.item
		delete newState.displayFeatures

		return {
			...newState,
			heading: {
				text: that.context.translate('Loading...'),
				icon: undefined
			}
		}
	},

	[at.itemFetch_Success]: (state, action) => {
		//	Get features we want to display
		const getFeatureTypesForDisplay = (myFeatures, fOrder) => {
			const features = myFeatures || []
			const newFeatures = []

			//	Order new/existing features
			fOrder.forEach((fType) => {
				let myFeature

				features.every((fe) => {
					if (fe.type === fType) {
						myFeature = fe
						return false
					}
					return true
				})

				//	Add a feature shell
				if (!myFeature) {
					myFeature = {
						type: fType,
						commentCount: 0,
						score: 0,
						subTypes: []
					}
				}
				if (featureTypes.indexOf(fType.toUpperCase()) !== -1) {
					newFeatures.push(myFeature)
				}
			})

			//	Add in any missed features
			features.forEach((fe) => {
				let hasFeature = false
				newFeatures.every((feat) => {
					if (feat.type === fe.type) {
						hasFeature = true
						return false
					}
					return true
				})

				if (!hasFeature) {
					newFeatures.push(fe)
				}
			})

			//	Sort by score
			newFeatures.sort((a, b) => b.score - a.score)

			return newFeatures
		}

		let displayFeatures = []
		const item = action.payload.item
		if (item && item.itemType) {
			const fOrder = getDefaultFeatureTypes(item.itemType)
			displayFeatures = getFeatureTypesForDisplay(item.features, fOrder)
		}
		return {
			...state,
			item,
			displayFeatures,
			heading: {
				text: `${item.brandName} ${item.itemName}`,
				icon: undefined
			}
		}
	},

	[at.itemFetch_Fail]: (state, action) => ({
		...state,
		...showAppMessage(that.context.translate('Cannot find item with key {itemKey}', { itemKey: action.payload.itemKey }))
	}),

	[at.itemPostsFetch_Success]: (state, action) => ({
		...state,
		itemPosts: action.payload.posts
	}),

	[at.itemBrandFetch_Success]: (state, action) => ({
		...state,
		brand: action.payload.brand
	}),

	[at.itemFeatureVotesFetch_Success]: (state, action) => ({
		...state,
		userVotes: {
			...state.userVotes,
			...maybe({
				...action.payload.userVotes.reduce((obj, vote) => {
					obj[vote.featureType] = vote // eslint-disable-line no-param-reassign
					return obj
				}, {})
			}, action.payload.userVotes)
		}
	}),

	[at.itemEdit]: (state, action) => ({
		...state,
		itemDraft: action.payload.itemDraft
	}),

	[at.itemVersionAdd_Success]: (state, action) => ({
		...state,
		recentlyAddedItems: [...new Set([...(state.recentlyAddedItems || []), action.payload.itemKey])]
	}),

	[at.ITEM_FEATURE_VOTE]: (state, action) => {
		const { featureType, vote, prevVote } = action.payload

		const bV = voteValue(prevVote ? prevVote.type : voteTypes.NEUTRAL, true)
		const aV = voteValue(vote.type)
		const diffValue = bV + aV

		//	Update the feature's local vote.
		const displayFeatures = Object.assign([], state.displayFeatures)
		if (displayFeatures && displayFeatures.length > 0) {
			displayFeatures.forEach((fe, idx) => {
				if (fe.type === featureType) {
					displayFeatures[idx].score += diffValue
				}
			})
		}

		return {
			...state,
			displayFeatures
		}
	},

	[at.itemOwnSet_Success]: (state, action) => {
		if (state.item && state.item.itemKey === action.payload.item.itemKey) {
			let countOwned = state.item.countOwned || 0
			if (action.payload.own !== state.item.own) {
				countOwned += action.payload.own ? 1 : -1
			}
			countOwned = countOwned > 0 ? countOwned : 0
			return ({
				...state,
				item: {
					...state.item,
					countOwned
				}
			})
		}
		return state
	},

	[at.itemWantSet_Success]: (state, action) => {
		if (state.item && state.item.itemKey === action.payload.item.itemKey) {
			let countWanted = state.item.countWanted || 0
			if (action.payload.want !== state.item.want) {
				countWanted += action.payload.want ? 1 : -1
			}
			countWanted = countWanted > 0 ? countWanted : 0
			return ({
				...state,
				item: {
					...state.item,
					countWanted
				}
			})
		}
		return state
	},

	[at.itemOwnSet_Fail]: state => (state.item ? ({
		...state,
		item: {
			...state.item // re-set the same item - so the item (the OwnWant count particularly) re-renders (resetting the optimistic UI update)
		}
	}) : state),

	[at.itemWantSet_Fail]: state => (state.item ? ({
		...state,
		item: {
			...state.item
		}
	}) : state),

	[at.itemDraftCreate]: state => ({
		...state,
		itemDraft: {}
	})

})



// WEBPACK FOOTER //
// ./src/redux/reducers/itemReducer.js